import { MetadataEntityFieldType } from '../model/metadata.entity.field.types';

export const isPrimitiveType = (type: MetadataEntityFieldType | [MetadataEntityFieldType]): boolean => {

    if (Array.isArray(type)) {
        type = type[0];
    }

    const primitiveTypes = [
        MetadataEntityFieldType.Date,
        MetadataEntityFieldType.DateTime,
        MetadataEntityFieldType.String,
        MetadataEntityFieldType.StringAlphaNumeric,
        MetadataEntityFieldType.StringAlpha,
        MetadataEntityFieldType.Phone,
        MetadataEntityFieldType.Email,
        MetadataEntityFieldType.Url,
        MetadataEntityFieldType.Boolean,
        MetadataEntityFieldType.Enum,
        MetadataEntityFieldType.Time,
        MetadataEntityFieldType.Number,
        MetadataEntityFieldType.Percentage,
        MetadataEntityFieldType.Currency,
    ];

    return primitiveTypes.includes(type);

}

export const isNotPrimitiveType = (type: MetadataEntityFieldType | [MetadataEntityFieldType]): boolean => {
    return !isPrimitiveType(type);
}